export const REVIEW_SORT_OPTION_TABLE = Object.freeze({
  advertising: "광고/사기",
  obscenity: "음란성/선정성",
  termAbuse: "욕설/인신공격",
  prsinExpsr: "개인정보노출",
  directInput: "직접입력",
});
